/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Kit 2 React components

// Material Kit 2 React examples
import Grid2 from "@mui/material/Unstable_Grid2";
import AssessmentCounterCard from "views/Cards/CounterCards/AssessmentCounterCard";
import { FormControl, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import React, { useState } from "react";
import MKTypography from "../../../components/MKTypography";
import MKBox from "../../../components/MKBox";
import categoryColor from "../../../utils/categoryColor";
import assessments from "../../../store/constant/assessments";

const categories = ["water", "ecology", "agriculture"];
function Assessments() {
  const Times = ["2000", "2010", "2020"];
  const [TimeSelected, setTimeSelected] = useState("2020");
  const handleTimeChange = (event) => {
    // 这是一个事件函数，发生这个事件时，调用下面的代码
    setTimeSelected(event.target.value);
  };
  return (
    <Grid2 container xs={12}>
      <Grid2 container xs={12}>
        <MKBox display="flex" alignItems="center" px={{ lg: 2, xl: 4, xxl: 6, xxxl: 12 }}>
          <FormControl variant="outlined">
            <Select id="time-period-select" value={TimeSelected} onChange={handleTimeChange}>
              {Times.map((time) => (
                <MenuItem key={time} value={time}>
                  {time}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </MKBox>
      </Grid2>
      {categories.map((category) => (
        <Grid2 container xs={4} key={category} px={{ xl: 1, xxl: 2, xxxl: 4 }}>
          <Grid2 container xs={12} justifyContent="space-evenly" alignItems="center" spacing={2}>
            <Grid2 xs={12}>
              <MKBox display="flex" alignItems="center" sx={{ py: 1, justifyContent: "center" }}>
                <MKTypography
                  variant="h3"
                  textTransform="capitalize"
                  sx={{
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {category}
                </MKTypography>
              </MKBox>
            </Grid2>

            {assessments
              .filter((a) => a.category === category)
              .map(({ id, title, assessment, decimal, suffix }, index) => (
                <Grid2 key={id} xs={12}>
                  <AssessmentCounterCard
                    category={category}
                    title={title}
                    decimals={decimal}
                    suffix={suffix}
                    bg={index === 0 ? categoryColor(category).main : categoryColor(category).main1}
                    count={
                      assessment
                        .filter((a) => a.region === "HKH Region")
                        .filter((y) => y.year === TimeSelected)[0].number
                    }
                  />
                </Grid2>
              ))}
          </Grid2>
        </Grid2>
      ))}
    </Grid2>
  );
}

export default Assessments;
